import baseURL from '../configUrl'

// 整体活跃
export const allActiveScl = baseURL + '/Daily/SchoolDetail'
export const allActiveTeaFirstDetail = baseURL + '/Daily/TeaFirstDetail'
export const allActiveTeaSecondDetail = baseURL + '/Daily/TeaSecondDetail'
export const gradeList = baseURL + '/Daily/GradeList'
export const subjectList = baseURL + '/Daily/SubjectList'
export const subjectTeaFirstDetail = baseURL + '/Daily/SubjectTeaFirstDetail'
export const subjectTeaSecondDetail = baseURL + '/Daily/SubjectTeaSecondDetail'

// 平台作业列表
export const homeworkList = baseURL + '/Excel/SchoolList'
export const homeworkDetail = baseURL + '/Excel/SchoolDetailList'
export const AIList = baseURL + '/Excel/AiCardList'
export const AIDetail = baseURL + '/Excel/AiCardDetailList'
// 课件分析
export const courseWareList = baseURL + '/Excel/CourseWareList'
export const courseWareDetail = baseURL + '/Excel/CourseWareDetailList'

// 区域学校题库分析
export const localeUseDownload = baseURL + '/ExercisePool/LocaleUseDownload'
export const localeUseDetailsDownload = baseURL + '/ExercisePool/LocaleUseDetailsDownload'
export const schoolUseDownload = baseURL + '/ExercisePool/SchoolUseDownload'

export const downLoadHteAnswerTimeDownload = baseURL + '/Hte/HteAnswerTimeDownload' // 作业用时下载
